module.exports = __webpack_public_path__ + "static/img/logo01.c75e8e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo01.png
// module id = SUN6
// module chunks = 0